import iFrameResize from 'iframe-resizer/js/iframeResizer';

// Get all iframe elements with the specified class
const iframes = document.querySelectorAll('.resize-iframe');

// Loop through each iframe and initialize resizing
iframes.forEach((iframe) => {
  iFrameResize({}, iframe);
});
